import React, { useState } from 'react';

import PropTypes from 'prop-types';
import Button from '@tds/core-button';
import Notification from '@tds/core-notification';

import request from '../../../../../utils/request';
import {
  AddContainer,
  AddingMain,
  AddActions,
  AddHeading,
  AddInput
} from '../css';

const Add = ({ fetchData }) => {
  const [domainName, setDomainName] = useState(null);
  const [addingMode, setAddingMode] = useState(false);
  const [validationError, setValidationError] = useState(false);

  const addDealership = async () => {
    try {
      if (!domainName) {
        setValidationError(true);
        return;
      }

      const result = await request.post(`/domains`, {
        name: domainName
      });

      if (result && result.status === 200) {
        setDomainName('');
        setAddingMode(false);
        fetchData();
      }
    } catch (err) {
      setDomainName('');
      setAddingMode(false);
      throw err;
    }
  };

  return (
    <AddContainer>
      {!addingMode && (
        <button type="button" className="frg-button color-purple" onClick={() => setAddingMode(true)}>
          Add Domain
        </button>
      )}
      {addingMode && (
        <AddingMain>
          <AddHeading>Add Domain</AddHeading>
          <AddActions>
            <AddInput
              type="text"
              placeholder="domain name..."
              value={domainName}
              onChange={({ target: { value } }) => setDomainName(value)}
            />
            <Button type="button" onClick={addDealership}>
              Add
            </Button>
            <Button
              variant="secondary"
              type="button"
              onClick={() => setAddingMode(false)}
            >
              Cancel
            </Button>
          </AddActions>
          <p>
            <strong>Note:</strong> Please write proper domain consisting of
            domain name and suffix (e.g. telus.com)
          </p>
          {validationError && (
            <Notification
              variant="error"
              dismissible
              onExit={() => setValidationError(false)}
              copy="en"
            >
              Please make sure the domain name is not empty
            </Notification>
          )}
        </AddingMain>
      )}
    </AddContainer>
  );
};

Add.propTypes = {
  fetchData: PropTypes.func.isRequired
};

export default Add;
